import { useQuery } from '@tanstack/react-query'
import axAPI from 'httpConfig'
import { IResponseTabs } from 'models'

export const useGetTabsForGroups = () => {
	const { data, refetch, isError, isLoading } = useQuery({
		queryKey: ['groupsListTabs'],
		queryFn: async () => {
			const response = await axAPI.get<unknown>(`/groups/list/tabs`)
			return (response as { data: IResponseTabs }).data.tabs
		},
	})

	return {
		data,
		isLoading,
		isError,
		refetch,
	}
}
